module.exports = __webpack_public_path__ + "img/img-istp.dc26d853.jpg";